import React from 'react';
import { Typography } from '@material-ui/core';
import { Box, Switch } from "@mui/material";
import { styled } from '@mui/material/styles';
import { tUi } from '../../../../../../../utils/dq_lc';

const EditModeToolbarWrapper = styled(Box)(({ theme }) => ({
    position: 'relative',
    width: '100%',
    backgroundColor: '#EE6D29',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px 110px 15px 110px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    animation: 'fadeIn 0.3s ease-out',
    '@keyframes fadeIn': {
        from: {
            opacity: 0,
            transform: 'translateY(-10px)',
        },
        to: {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
    [theme.breakpoints.down('sm')]: {
        height: 'auto',
        minHeight: '44px',
        padding: '8px 12px',
        flexWrap: 'wrap',
        gap: '6px',
        borderRadius: 0,
    },
}));

const EditModeToolbar = ({
    currentEditLanguage,
    showEnglishContent,
    onToggleLanguage,
    uiLocale = 'en-US',
}) => {
    return (
        <Box sx={{
            width: { xs: 'calc(100% + 24px)', sm: 'calc(100% + 128px)' },
            marginLeft: { xs: '-12px', sm: '-64px' },
            marginRight: { xs: '-12px', sm: '-64px' },
            marginTop: { xs: '-8px', sm: '-10px' },
            marginBottom: { xs: 0, sm: '10px' },
        }}>
            <EditModeToolbarWrapper>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: '6px', sm: '12px' }, flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontSize: { xs: '13px', sm: '15px' }, fontWeight: 'bold', letterSpacing: '0.3px', color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {tUi('preview.editModeActive', uiLocale)}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: '6px', sm: '10px' }, paddingRight: '0', flexShrink: 0 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: '4px', sm: '8px' } }}>
                        <Typography sx={{
                            fontSize: { xs: '11px', sm: '13px' },
                            fontWeight: showEnglishContent ? 400 : 600,
                            color: '#fff',
                            opacity: showEnglishContent ? 0.7 : 1,
                            minWidth: { xs: '22px', sm: '28px' },
                            textAlign: 'right'
                        }}>
                            {currentEditLanguage?.toUpperCase()}
                        </Typography>
                        <Switch
                            checked={showEnglishContent}
                            onChange={onToggleLanguage}
                            size="small"
                            sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': {
                                    color: '#fff',
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                    backgroundColor: '#fff',
                                },
                                transform: { xs: 'scale(0.8)', sm: 'scale(1)' },
                                transformOrigin: 'center',
                            }}
                        />
                        <Typography sx={{
                            fontSize: { xs: '11px', sm: '13px' },
                            fontWeight: showEnglishContent ? 600 : 400,
                            color: '#fff',
                            opacity: showEnglishContent ? 1 : 0.7,
                            minWidth: { xs: '22px', sm: '28px' },
                            textAlign: 'left'
                        }}>
                            EN
                        </Typography>
                    </Box>
                </Box>
            </EditModeToolbarWrapper>
        </Box>
    );
};

export default EditModeToolbar;
